<template>
  <div id="app">
    <div class="container container-h">
      <el-carousel class="banner">
        <el-carousel-item v-for="(item, k) in adList" :key="k">
          <img :src="item" />
        </el-carousel-item>
      </el-carousel>
      <div class="tabView">
        <div :class="tabIndex == 0 ? 'active' : ''" @click="switchGame(0)">
          <span>香港28</span>
        </div>
        <div :class="tabIndex == 1 ? 'active' : ''" @click="switchGame(1)">
          <span>加拿大28</span>
        </div>
      </div>

      <div class="lotItem">

        <div class="lot-latest">

          <div class="section">
            <div class="t-logo">
              <template v-if="tabIndex == 0">
                <img src="./assets/images/hk28.png" />
              </template>
              <template v-else>
                <img src="./assets/images/jnd28.png" />
              </template>

            </div>
            <div class="latestNumInfo">
              <div>
                <span>最新：</span>
                <span class="lastNum"> {{ lastNumInfo.openNum }}</span>
                <span style="margin-left: 10px;">期</span>
              </div>
              <div class="queryOpenNum">
                <div class="btn-sm">
                  <i class="el-icon-arrow-left" style="font-weight: bold;"></i>
                </div>
                <el-dropdown @command="handleCommand" class="project-container">
                  <div class="btn-sm" style="border-left: none; border-right: none;">
                    {{ queryOpenNum.openNum }}
                    <i class="el-icon-caret-bottom" />
                  </div>
                  <el-dropdown-menu slot="dropdown" class="project-dropdown">
                    <el-dropdown-item v-for="(v, k) in tableData" :key="k" :command="v">{{ v.openNum }}</el-dropdown-item>

                  </el-dropdown-menu>
                </el-dropdown>
                <div class="btn-sm">
                  <i class="el-icon-arrow-right" style="font-weight: bold;"></i>
                </div>
              </div>
            </div>

          </div>

          <div class="section opentime">

            <span>下一期</span>
            <b>{{ nextNumTime[0] }}</b>
            <span>分</span>
            <b>{{ nextNumTime[1] }}</b>
            <span>秒</span>

          </div>

          <div class="section" v-if="showWait">
            <div><img src="./assets/images/clock.jpg" /> </div>
            <div style="margin-left: 10px;color: #8d8d8d;"><span>等待结果</span></div>
            <div><img src="./assets/images/icon-status-status-dots-anim-16.gif" /> </div>
          </div>
          <div class="section " style="position: relative; min-width: 50%" >
            <scratch-card v-if="showResultModel == 1" elementId="scratch" width="100%" height="100%" :moveRadius="15"
              :ratio="0.8" coverImg="/images/mark.png" :result="result" style="position: absolute;">
            </scratch-card>
            <div class="cyanBlue  lot-result">{{ queryOpenNum.result[0] }}</div>
            <div class="ml5"><span>+</span></div>
            <div class="cyanBlue  lot-result ml5">{{ queryOpenNum.result[1] }}</div>
            <div class="ml5"><span>+</span></div>
            <div class="cyanBlue  lot-result ml5">{{ queryOpenNum.result[2] }}</div>
            <div class="ml5"><span>=</span></div>
            <div class="skyBlue  lot-result ml5">{{ getSum() }}</div>
            <div style="background-color: #ccc; width: 1px; height: 60%; margin-left:10px;"></div>
            <div style="display: flex;flex-direction:row; ">
              <div style="margin-left: 10px;">
                <div class="badge blue-info" :class="isBigNum() ? 'red-info' : ''">
                  <template v-if="isBigNum()">大</template>
                  <template v-else>小</template>
                </div>
              </div>
              <div style="margin-left: 10px;">
                <div class="badge blue-info" :class="!isOddNumber() ? 'red-info' : ''">
                  <template v-if="isOddNumber()">单</template>
                  <template v-else>双</template>
                </div>
              </div>
            </div>
            <div style=" position: absolute; right: 0;">
              <span class="shuli" @click="setModel(1)" v-if="showResultModel == 0">刮奖模式</span>
            </div>
          </div>
        </div>

      </div>
      <div class="lotIContent">
        <div>
          <div class="dataTabView">
            <div class="dataTab " :class="showTableIndex == 0 ? 'active' : ''" @click="switchTab(0)">
              <i class="el-icon-lock"></i>
              <span>结果</span>
            </div>
            <div class="dataTab" :class="showTableIndex == 1 ? 'active' : ''" @click="switchTab(1)">
              <i class="el-icon-picture-outline"></i>
              <span>走势图</span>
            </div>
            <div class="dataTab" :class="showTableIndex == 2 ? 'active' : ''" @click="switchTab(2)">
              <i class="el-icon-picture-outline"></i>
              <span>数据</span>
            </div>
            <div class="dataTab" :class="showTableIndex == 3 ? 'active' : ''" @click="switchTab(3)">
              <i class="el-icon-picture-outline"></i>
              <span>组合预测</span>
            </div>
            <div class="dataTab" :class="showTableIndex == 4 ? 'active' : ''" @click="switchTab(4)">
              <i class="el-icon-picture-outline"></i>
              <span>杀组合预测</span>
            </div>
            <div class="dataTab" :class="showTableIndex == 5 ? 'active' : ''" @click="switchTab(5)">
              <i class="el-icon-picture-outline"></i>
              <span>大小预测</span>
            </div>
          </div>
        </div>
        <div style="width: 100%; overflow: hidden;">
          <general-table :table-data="tableData" v-if="showTableIndex == 0"></general-table>
          <trendTable :table-data="tableData" v-if="showTableIndex == 1"></trendTable>
          <dataTable :table-data="tableData" v-if="showTableIndex == 2"></dataTable>
          <guessTable :table-data="tableData" v-if="showTableIndex == 3"></guessTable>
          <guessTable2 :table-data="tableData" v-if="showTableIndex == 4"></guessTable2>
          <guessTable3 :table-data="tableData" v-if="showTableIndex == 5"></guessTable3>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import generalTable from './components/generalTable.vue';
import trendTable from './components/trendTable.vue';
import dataTable from './components/dataTable.vue';
import guessTable from './components/guessTable.vue';
import guessTable2 from './components/guessTable2.vue';
import guessTable3 from './components/guessTable3.vue';
import scratchCard from 'lzy-scratch-card'
export default {
  name: 'App',
  components: {
    generalTable,
    trendTable,
    dataTable,
    guessTable,
    guessTable2,
    guessTable3,
    scratchCard
  },
  data() {
    return {
      adList: ['/images/ad.jpg', '/images/ad_bak0625.jpg'],
      activeName: "xy28_1",
      tableData: [],
      showTableIndex: 0,
      tabIndex: 0,
      listQuery: {
        pageLimit: 50,
        pageIndex: 1
      },
      lastNumInfo: {
        openNum: "",
        openTime: 0,
        stopBetTime: 0
      },
      nextNumTime: ['--', '--'],
      showWait: false,
      timeHandle: null,
      queryOpenNum: {
        openNum: "",
        result: ["--", '--', '--']
      },
      result: "",
      showResultModel: 0
    }
  },
  created() {
    this.getAustralia28LastNumInfo()
    this.timeHandle = setInterval(this.calcNextTime, 1000);
  },
  destroyed() {
    if (this.timeHandle != null) {
      clearInterval(this.timeHandle);
    }
  },
  methods: {
    calcResult() {
      this.tableData.forEach(item => {
        let sumResult = 0
        item.openTime = this.getdate(item.openTime)
        if (item.result == null || item.result.length == 0) {
          console.log("item.result == null")
        } else {
          item.result.forEach(value => {
            sumResult += value
          })
          item.sumResult = sumResult
        }
      })
    },
    switchTab(tabIndex) {
      this.showTableIndex = tabIndex
    },
    switchGame(tabIndex) {
      this.tabIndex = tabIndex
      this.queryOpenNum = {
        openNum: "",
        result: ["--", '--', '--']
      }
      if (tabIndex == 0) {
        this.getAustralia28LastNumInfo()
      } else {
        this.getCanada28LastNumInfo()
      }
    },
    async queryAustralia28Result() {
      let res = await this.$axios.post("https://apis.hkpc28.com/api3/hkong28/getResultRecord", this.listQuery)
      this.tableData = res.data
      this.queryOpenNum = {
        openNum: "",
        result: ["--", '--', '--']
      }
      if (this.tableData.length > 0) {
        if (this.showResultModel == 1) {
          this.showResultModel = 0
          this.$nextTick(() => {
            this.showResultModel = 1
            this.queryOpenNum = this.tableData[1]
          })
        } else {
          this.queryOpenNum = this.tableData[1]
        }
      }
   
      this.calcResult();
    },
    async getAustralia28LastNumInfo() {
      let res = await this.$axios.post("https://apis.hkpc28.com/api3/hkong28/getLastNumInfo", {})
      this.lastNumInfo = res.data
      this.queryAustralia28Result()
    },
    async getCanada28LastNumInfo() {
      let res = await this.$axios.post("https://apis.pcz28.com/api/canada28/getLastNumInfo", {})
      this.lastNumInfo = res.data
      this.queryCanada28Result()
    },
    async queryCanada28Result() {
      let res = await this.$axios.post("https://apis.pcz28.com/api/canada28/getResultRecord", this.listQuery)
      this.tableData = res.data
      this.queryOpenNum = {
        openNum: "",
        result: ["--", '--', '--']
      }
      if (this.tableData.length > 0) {
        if (this.showResultModel == 1) {
          this.showResultModel = 0
          this.$nextTick(() => {
            this.showResultModel = 1
            this.queryOpenNum = this.tableData[1]
          })
        } else {
          this.queryOpenNum = this.tableData[1]
        }
      }
      this.calcResult();
    },
    calcNextTime() {

      if (this.lastNumInfo.stopBetTime == 0) return
      let time2 = this.lastNumInfo.stopBetTime - (new Date()).valueOf() / 1000
      let time3 = this.lastNumInfo.openTime - (new Date()).valueOf() / 1000
      time2 = parseInt(time2)
      if (time3 <= 0) {

        if (this.tabIndex == 0) {
          this.getAustralia28LastNumInfo()
        } else {
          this.getCanada28LastNumInfo()
        }

      }
      if (time2 <= 0) {
        this.$set(this.nextNumTime, 0, "--")
        this.$set(this.nextNumTime, 1, "--")
        this.showWait = true
        return
      }
      this.showWait = false
      let mTime = parseInt(time2 / 60)
      let sTime = time2 % 60
      if (mTime < 10) mTime = '0' + mTime;
      if (sTime < 10) sTime = '0' + sTime
      this.$set(this.nextNumTime, 0, mTime)
      this.$set(this.nextNumTime, 1, sTime)

    },
    handleCommand(command) {
      if (this.showResultModel == 1) {
        this.showResultModel = 0
        this.$nextTick(() => {
          this.showResultModel = 1
          this.queryOpenNum = command
        })
      } else {
        this.$nextTick(() => {
          this.queryOpenNum = command
        })
      }
    },
    getSum() {
      return this.queryOpenNum.result[0] + this.queryOpenNum.result[1] + this.queryOpenNum.result[2]
    },
    isBigNum() {
      if (this.getSum() >= 14) return true
      return false
    },
    isOddNumber() {
      if (this.getSum() == 0 || (this.getSum() % 2 == 0)) return false
      return true
    },
    setModel(model) {
      this.showResultModel = model
    },
    getdate(times) {
      var now = new Date(times * 1000),
        y = now.getFullYear(),
        m = now.getMonth() + 1,
        d = now.getDate();
      return y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d) + " " + now.toTimeString().substr(0, 8);
    }
  }
}
</script>
<style>
.project-dropdown {

  height: 300px;
  overflow: auto;
}

.project-dropdown::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  background-color: #F5F5F5;
}

.project-dropdown::-webkit-scrollbar-track {
  /*-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);*/
  border-radius: 10px;
  background-color: #F5F5F5;
}
</style>

